import feng from '../../../assets/images/production/fengSeries/feng.png'
import leftBall from '../../../assets/images/production/fengSeries/left-ball.png'

import styles from './style.module.scss'

function FengSeries() {
    return (
      <div
        className={`production-series-wrapper  ${styles['feng-series-wrapper']}`}
      >
        <div className={`banner ${styles['banner']}`}>
          <div className="title">电子取证产品</div>
          <div className="content">
            构建多源数据采集接入能力、贴合业务场景的取证分析能力，打造了“多场景、多形态、高性能、高产出”
            的电子取证产品体系，满足现场勘查、终端取证、证据分析、电子物证实验室等各类业务场景。
          </div>
        </div>
        <div
          className={`series-container ${styles['series-container']}`}
        >
          <div
            className={`series-content ${styles['series-content']}`}
          >
            <img src={leftBall} alt="" />
            <div>
              <div className={styles['series-left']}>
                <div
                  className={`introduction-title ${styles['introduction-title']}`}
                >
                  <p>
                    <span>“烽”系列</span>
                    <span>
                      —— 高效、便捷的电子数据采集产品
                    </span>
                  </p>
                  <p>
                    该系列产品主要针对涉案和违法犯罪嫌疑人的持有移动智能终端设备等进行数据采集的产品，广泛应用于公安入所采集、涉诈受害人/报案人定向采集、刑事侦查现勘采集等场景。
                  </p>
                </div>
                <div
                  className={
                    styles['introduction-container']
                  }
                >
                  <div
                    className={`introduction-item ${styles['introduction-item']}`}
                  >
                    <div className={styles['img']}></div>
                    <div
                      className={
                        styles['introduction-content']
                      }
                    >
                      <p>首创有线+无线并行传输提取模式，</p>
                      <p>采集速度提升30% </p>
                    </div>
                  </div>
                  <div
                    className={`introduction-item ${styles['introduction-item']}`}
                  >
                    <div className={styles['img']}></div>
                    <div
                      className={
                        styles['introduction-content']
                      }
                    >
                      <p>
                        集成VPN工具，有效采集机身数据和应用云端
                      </p>
                      <p>
                        数据（含境外），更好地支撑挖掘情报线索
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles['series-right']}>
                <img src={feng} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default FengSeries